import GenericAPI, { CONTENT_TYPE } from "../GenericApi";
class SupplierPaymentApi extends GenericAPI {

    PURCHASE_INFO_ENDPOINT="/api/purchaseInformation"
    GET_ORDERS_ENDPOINT="/api/purchaseInformation/productPurchase"
    REJECT_REQUEST_ENDPOINT="/api/purchaseInformation/reject"
    PAYMENT_METHOD_ENDPOINT="/api/paymentMethod"
    PAYMENT_REQUEST_ENDPOINT="/api/paymentRequest"
    UPDATE_PAYMENT_STATUS_ENDPOINT="/api/paymentRequest/updateStatusBySupplier"
    CARD_INFO_ENDPOINT="/api/cardInformation"
    PAYMENT_DETAIL_ENDPOINT="/api/paymentDetail"
    CANCEL_SUBSCRIPTION_ENDPOINT="paymentDetail/SubscriptionCancel"

    async getProductDetails(supplierId) {
        const payload =  {
            supplierId
        }
        return this.get(this.PURCHASE_INFO_ENDPOINT, payload, true);
    }

    async placeOrderRequest(payload) {
        return this.post(this.PURCHASE_INFO_ENDPOINT, payload, CONTENT_TYPE.URLENCODED, true)
    }

    async getOrders(supplierId) {
        const payload =  {
            supplierId
        }
        return this.get(this.GET_ORDERS_ENDPOINT, payload, true);
    }

    async rejectRequest(data) {
        return this.put(this.REJECT_REQUEST_ENDPOINT, data, CONTENT_TYPE.URLENCODED, true);
    }

    async getPaymentMethod(userId) {
        const payload =  {
            userId
        }
        return this.get(this.PAYMENT_METHOD_ENDPOINT, payload, true);
    }

    async addPaymentMethod(userId, isPayID, isEFTACCOUNT, payID, EFTAccountName, EFTAccountNumber, EFTBSB) {
        const isCreditCard = 1
        const isPayId = isPayID ? 1 : 0
        const isEFT = isEFTACCOUNT ? 1 : 0
        const payload = {
            userId,
            isCreditCard,
            isPayId,
            isEFT,
            payID,
            EFTAccountName,
            EFTAccountNumber,
            EFTBSB
        }
        return this.post(this.PAYMENT_METHOD_ENDPOINT, payload, CONTENT_TYPE.JSON, true);
    }

    async updatePaymentMethod(paymentId, userId, isPayID, isEFTACCOUNT, payID, EFTAccountName, EFTAccountNumber, EFTBSB) {
        const isCreditCard = 1
        const isPayId = isPayID ? 1 : 0
        const isEFT = isEFTACCOUNT ? 1 : 0
        const payload = {
            paymentId,
            userId,
            isCreditCard,
            isPayId,
            isEFT,
            payID,
            EFTAccountName,
            EFTAccountNumber,
            EFTBSB
        }
        return this.put(this.PAYMENT_METHOD_ENDPOINT, payload, CONTENT_TYPE.URLENCODED, true);
    }

    async getPaymentStatus(supplierId) {
        const payload =  {
            supplierId
        }
        return this.get(this.PAYMENT_REQUEST_ENDPOINT, payload, true);
    }

    async sendPaymentRequest(data) {
        return this.post(this.PAYMENT_REQUEST_ENDPOINT, data, CONTENT_TYPE.URLENCODED, true);
    }

    async updatePaymentStatus(data) {
        return this.put(this.UPDATE_PAYMENT_STATUS_ENDPOINT, data, CONTENT_TYPE.URLENCODED, true);
    }

    async getPaymentCardList(userId) {
        const payload =  {
            userId
        }
        return this.get(this.CARD_INFO_ENDPOINT, payload, true);
    }

    async addCardDetail(data) {
        return this.post(this.CARD_INFO_ENDPOINT, data, CONTENT_TYPE.URLENCODED, true);
    }

    async addPaymentToken(data) {
        return this.post(this.PAYMENT_DETAIL_ENDPOINT, data, CONTENT_TYPE.URLENCODED, true);
    }

    async cancelSubscription(data) {
        return this.post(this.CANCEL_SUBSCRIPTION_ENDPOINT, data, CONTENT_TYPE.URLENCODED, true);
    }
}

export default new SupplierPaymentApi();
